interface ServerDisplayMessageBlock {
  type: 'text';
  value: {
    text: string;
  };
}

interface ServerDisplayMessageContent {
  message_blocks: Array<ServerDisplayMessageBlock>;
}

/**
 * Extract a string from DisplayMessageChatEventNode.content.
 *
 * Currently, this is an untyped value sent on the GraphQL API, so we cast. In the future,
 * we should make the GraphQL shape itself typesafe.
 */
export default function extractDisplayMessageText(content: ServerDisplayMessageContent): string {
  // Example content format:
  // {"message_blocks":[{"type":"text","value":{"text":"Hello","annotations":[]}}]}
  return content.message_blocks
    .filter((block) => block.type === 'text')
    .map((block) => block.value.text)
    .join('\n');
}
